import React from "react";

export async function getFcmToken() {
  return "";
}

export default function Notify() {
  return <></>;
}
